import api from "@/services/api";

export interface RequestPagBankSmsPayload {
  bank_branch: string;
  account_number: string;
}

export interface RequestPagBankSmsResponse {
  phone_number: string;
  retry_after_seconds: number;
}

class RequestPagBankSms {
  execute = async (payload: RequestPagBankSmsPayload) => {
    const response = await api().post(
      "/partner/pagbank-connect/sms/request",
      payload
    );
    return response.data as RequestPagBankSmsResponse;
  };
}

export { RequestPagBankSms };
